module.exports = __webpack_public_path__ + "img/organization.86f19c3d.svg";